import React from 'react';


export default function Logo(props={
  floating: false,
  margin: 40,
  large: false
}) {
  const { floating, margin, large } = props;

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: large ? '16px' : '12px',
    margin: floating ? 0 : margin,
    float: floating ? 'right' : 'none'
  };

  const imgSize = large ? '48px' : '32px';
  const fontSize = large ? '32px' : '20px';

  return (
    <div style={containerStyle} role="banner">
      <span style={{ fontSize, fontWeight: 'bold', color: 'var(--text-color, #1e293b)', letterSpacing: '-0.5px' }} aria-label="tele-LOOK">
        tele-LOOK
      </span>
    </div>
  );
}
